import React, { Component } from 'react';
import {Paper, Grid, Typography, Button, IconButton, Link} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
// import Settings from '@material-ui/icons/Settings';
import DatasheetView from './DatasheetView';
import moment from 'moment';
import {AssignmentTurnedInTwoTone,VisibilityRounded } from '@material-ui/icons';
import DatePicker from './DatePicker';

export default class MyInterventions extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: false,
            error_message: '',
            querying: true,
            pending_assessments_array: [],
            current_record: {},
            view_details: false,
            edit_completion_date:false,
            writing: false,
            new_completed_date: null
        }

        this.datasheetFieldSpecs = [
            { field: 'toggle', headerName: 'Mark as Complete / Incomplete?', width: 80, headerAlign: 'center',
            sortable: false,
            renderCell: (parms) => (
                <IconButton 
                    onClick={()=>this.markComplete(parms)} 
                >
                    <AssignmentTurnedInTwoTone color='primary'/>
                </IconButton>
            )},
            { field: 'view', headerName: 'Details', width: 80, headerAlign: 'center',
            sortable: false,
            renderCell: (parms) => (
                <IconButton 
                    onClick={()=>this.viewAssessment(parms)} 
                >
                    <VisibilityRounded/>
                </IconButton>
            )},
            { field: 'intervention', headerName: 'Intervention', width: 250},
            { field: 'created', headerName: 'Assigned', width: 120},
            { field: 'assignor', headerName: 'Assigned By', width: 160},
            { field: 'deadline_date', headerName: 'Deadline', width: 120},
            { field: 'completed_date', headerName: 'Completed', width: 130},
            { field: 'approved', headerName: 'Approved?', width: 120, sortable:false, headerAlign:'center', align:'center'},
        ]
    }

    componentDidMount = () => {

        Gserv.sendCommand('query_my_interventions',this.props.gwt)
        .then(reply=>{
            // console.log('query_my_interventions reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (query_my_interventions) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (query_my_interventions) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                
                //clean formats for display
                if (reply.Records){
                let record_array = reply.Records;
                    let deadline_date = null;
                    let created = null;
                    let completed = null;
                    for (var i=0;i<record_array.length;i++){
                        if (record_array[i].deadline_date){
                            deadline_date = new moment(record_array[i].deadline_date).format("YYYY-MM-DD");
                            record_array[i].deadline_date = deadline_date;
                        }
                        created = new moment(record_array[i].created).format("YYYY-MM-DD");
                        record_array[i].created = created;
                        if (record_array[i].completed_date){
                            completed = new moment(record_array[i].completed_date).format("YYYY-MM-DD");
                            record_array[i].completed_date = completed;
                        }
                        record_array[i].approved = record_array[i].approved? "YES" : null;

                    }
                }
                this.setState({querying:false, pending_assessments_array:reply.Records?reply.Records : []});

            }
        });
    };
   
    resetMe = () => {
        this.setState({error: false,error_message: '',current_record: {}, view_details: false,edit_completion_date:false, new_completed_date:null,writing:false});
    }

    markComplete = (record) => {
        // console.log('record :>> ', record);
        if (record.row.approved==="YES"){
            this.setState({error:true,error_message:'Learning Intervention records which have already been approved, cannot be edited.'});
        } else {
            this.setState({
                current_record:record.row,
                edit_completion_date:true,
                error:false,
                error_message:''
            });
        }
    }
 
    viewAssessment = (record) => {
        // console.log('record :>> ', record);
        this.setState({
            current_record:record.row,
            view_details:true,
        });
    }

    handleCompletedUpdate = (fieldObj) => {
        if (fieldObj.value===''){fieldObj.value=null}
        this.setState({new_completed_date:fieldObj.value})
    }

    updateCompletedDate = () => {
        // console.log('called updateCompletedDate')
        if (this.state.new_completed_date) {

            this.setState({writing:true});
            Gserv.sendCommand('update_intervention_completion',this.props.gwt,{
                intervention_id: this.state.current_record.intervention_id,
                completed_date: this.state.new_completed_date
            })
            .then(reply => {
                // console.log('createNom reply :>> ', reply);
                if (reply.error){
                    console.log('error on return from Gserv (update_intervention_completion) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
                } else if (reply.Result!=="Success"){
                    console.log('error on return from Gserv (update_intervention_completion) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
                } else {
                    this.setState({error: false,error_message: '',current_record: {}, view_details: false,edit_completion_date:false, new_completed_date:null,pending_assessments_array:[],querying:true,writing:false});
                    this.componentDidMount();
                }
            });
        }
        //I.e. do nothing if there is no completed date value
    }

    clearCompletedDate = () => {
        // console.log('called clearCompletedDate');
        if (this.state.current_record.completed_date) {

            this.setState({writing:true});
            Gserv.sendCommand('update_intervention_completion',this.props.gwt,{
                intervention_id: this.state.current_record.intervention_id,
                completed_date: null
            })
            .then(reply => {
                // console.log('createNom reply :>> ', reply);
                if (reply.error){
                    console.log('error on return from Gserv (update_intervention_completion) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
                } else if (reply.Result!=="Success"){
                    console.log('error on return from Gserv (update_intervention_completion) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
                } else {
                    this.setState({error: false,error_message: '',current_record: {}, view_details: false,edit_completion_date:false, new_completed_date:null,pending_assessments_array:[],querying:true,writing:false});
                    this.componentDidMount();
                }
            });
        }
    }

    render() {return (
        <Grid
            container
            direction='column'
            justifyContent='flex-start'
            alignContent='flex-start'
            // style={{backgroundColor:'yellow'}}
        >
            {!this.state.edit_completion_date&&!this.state.view_details&&
            <Grid item>
            <Paper
                elevation={3}
                style={{
                    // backgroundColor:'yellow',
                    width:1070
                }}
            >

                <Typography style={{padding:10}}>
                    Required Learning Interventions
                </Typography>

                {/* Datagrid goes here */}
                <DatasheetView 
                    dataset={this.state.pending_assessments_array}
                    fieldspecs={this.datasheetFieldSpecs}
                    delete={false}
                    edit={false}
                    handleDelete={null}
                    handleEdit={null}
                    loading={this.state.querying}
                    deleteHeaderName={'Delete'}
                    pagesize={10}
                    height={500}
                />
            </Paper>
            </Grid>}

            {this.state.edit_completion_date&&!this.state.view_details&&
            <Grid item>
            <Paper
                elevation={3}
                style={{
                    // backgroundColor:'yellow',
                    width:1070
                }}
            >

                <Typography style={{padding:10}}>
                    Mark My Learning Intervention as Complete                    
                </Typography>

                <hr/>

                <Grid
                    container
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                    style={{padding:'20px'}}
                >

                    <Typography
                        style={{borderWidth:'1px',borderStyle:'solid',padding:'10px'}}
                    >
                        <strong>{this.state.current_record.intervention}</strong> assigned on {this.state.current_record.created} by <strong>{this.state.current_record.assignor}</strong>{this.state.current_record.deadline_date? ' required to be completed by ' : ''}<strong>{this.state.current_record.deadline_date? this.state.current_record.deadline_date : ''}</strong>
                    </Typography>   
                    <Typography
                        color='primary'
                        style={{paddingTop:'10px',marginBottom:'15px'}}
                    >
                        Please record / update the date on which this Learning Intervention was completed (or otherwise clear the date field if it's not yet complete) :
                    </Typography>

                    <Grid 
                        container
                        direction='row'
                        justifyContent='center'
                        alignItems='center'
                        style={{marginBottom:'15px'}}
                    >
                        <DatePicker
                            fieldMap={{
                                field: "completed_date",
                                headerName: "Completed On?",
                                f_inputType:'datepicker',
                                f_required:false,
                                f_show:true,
                                f_disable_past:false,
                                f_disable_future:true}}
                            setField={this.handleCompletedUpdate}
                            editRecord={this.state.current_record}
                            disabled={this.state.writing}
                        />

                    </Grid>

                    <Grid
                        container
                        direction='row'
                        justifyContent='center'
                        alignItems='center'
                    >        
                        <Button
                            variant='contained'
                            onClick={this.updateCompletedDate}
                            style={{marginLeft:'10px'}}
                            color='primary'
                            // type='submit'
                            disabled={this.state.writing}
                        >
                            Update Completion Date
                        </Button>

                        <Button
                            variant='contained'
                            onClick={this.clearCompletedDate}
                            style={{marginLeft:'10px'}}
                            // color='primary'
                            // type='submit'
                            disabled={this.state.writing}
                        >
                            Mark as Not Yet Complete
                        </Button>

                        <Button
                            variant='contained'
                            onClick={()=>this.resetMe()}
                            style={{marginLeft:'10px'}}
                            // color='primary'
                            // type='submit'
                            disabled={this.state.writing}
                        >
                            Cancel
                        </Button>
                    </Grid>

                </Grid>


                

            </Paper>
            </Grid>}

            {!this.state.edit_completion_date&&this.state.view_details&&
            <Grid item>
            <Paper
                elevation={3}
                style={{
                    // backgroundColor:'yellow',
                    width:1070
                }}
            >

                <Typography style={{padding:10}}>
                    Learning Intervention Details                    
                </Typography>
                <hr/>

                <Grid
                    container
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                    style={{padding:'20px'}}
                >
                    
                    <Typography
                        style={{borderWidth:'1px',borderStyle:'solid',padding:'10px',marginBottom:'15px'}}
                    >
                        <strong>{this.state.current_record.intervention}</strong> assigned on {this.state.current_record.created} by <strong>{this.state.current_record.assignor}</strong>{this.state.current_record.deadline_date? ' required to be completed by ' : ''}<strong>{this.state.current_record.deadline_date? this.state.current_record.deadline_date : ''}</strong>
                    </Typography>      

                    {this.state.current_record.intervention_narration&&
                    <Typography style={{marginBottom:'15px'}}><i>{this.state.current_record.intervention_narration}</i></Typography>}

                    {this.state.current_record.intervention_url&& 
                    <Link 
                        href={this.state.current_record.intervention_url}
                        target='_blank'
                        underline="hover"
                        style={{marginBottom:'15px'}}
                    >
                        {this.state.current_record.intervention_url}
                    </Link>}

                    {this.state.current_record.completed_date&&!this.state.current_record.approved&&
                    <Typography>
                        Status: Completed on {this.state.current_record.completed_date} : <strong>awating review</strong>.
                    </Typography>}

                    {!this.state.current_record.completed_date&&
                    <Typography>
                        Status: <strong>Not yet complete</strong>.
                    </Typography>}

                    {this.state.current_record.completed_date&&this.state.current_record.approved&&
                    <Typography>
                        Status: Completed on {this.state.current_record.completed_date} : <strong>approved</strong>.
                    </Typography>}
                    
                    <Grid 
                        container
                        direction='row'
                        justifyContent='center'
                        alignItems='center'
                        style={{marginBottom:'15px', marginTop:'15px'}}
                    >
                        <Button
                            variant='contained'
                            onClick={()=>this.resetMe()}
                            style={{marginLeft:'10px'}}
                            // color='primary'
                            // type='submit'
                            disabled={this.state.writing}
                        >
                            Back
                        </Button>
                    </Grid>

                </Grid>
                

            </Paper>
            </Grid>}

            <Grid item>
                <Typography color='secondary' style={{Width:1070,maxWidth:1070, textAlign:'center'}}>{this.state.error_message}</Typography>
                {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
            </Grid>

        </Grid>
    );}
    
}